
export const SUBSCRIPTION_REFRESH_EVENT = 'subscription:refresh';

export const emitSubscriptionRefresh = () => {
  window.dispatchEvent(new CustomEvent(SUBSCRIPTION_REFRESH_EVENT));
};

export const onSubscriptionRefresh = (callback: () => void) => {
  const handler = () => callback();
  window.addEventListener(SUBSCRIPTION_REFRESH_EVENT, handler);
  return () => window.removeEventListener(SUBSCRIPTION_REFRESH_EVENT, handler);
};


export const KANBANS_REFRESH_EVENT = 'kanbans:refresh';

export const emitKanbansRefresh = () => {
  window.dispatchEvent(new CustomEvent(KANBANS_REFRESH_EVENT));
};

export const onKanbansRefresh = (callback: () => void) => {
  const handler = () => callback();
  window.addEventListener(KANBANS_REFRESH_EVENT, handler);
  return () => window.removeEventListener(KANBANS_REFRESH_EVENT, handler);
};

